import { getProductRouterPath } from '../../utils';
import { axiosProvider } from '@/app/core/axios';
import {
  ApiResponse,
  DataDictionaryDiff,
  AscendQuestDataDictionarySchema,
  AwsS3Like,
  S3DataDictionay,
} from '@ssar-app/domain';

export const getDataDictionaries = async (): Promise<
  ApiResponse<S3DataDictionay[]>
> => {
  const response = await axiosProvider.apiClient.get<
    ApiResponse<S3DataDictionay[]>
  >(
    `/program/${encodeURIComponent(
      getProductRouterPath(),
    )}/aws/data-dictionaries`,
  );
  return response.data;
};

export const getSpecificDataDictionary = async (
  key: string,
  version: string,
): Promise<ApiResponse<AscendQuestDataDictionarySchema>> => {
  const response = await axiosProvider.apiClient.get<
    ApiResponse<AscendQuestDataDictionarySchema>
  >(
    `/program/${encodeURIComponent(
      getProductRouterPath(),
    )}/aws/data-dictionary?key=${encodeURIComponent(
      key || '',
    )}&version=${encodeURIComponent(version || '')}`,
  );
  return response.data;
};

export const getLatestDataDictionary = async (): Promise<
  ApiResponse<AscendQuestDataDictionarySchema>
> => {
  const response = await axiosProvider.apiClient.get<
    ApiResponse<AscendQuestDataDictionarySchema>
  >(
    `/program/${encodeURIComponent(
      getProductRouterPath(),
    )}/aws/latest-data-dictionary`,
  );
  return response.data;
};

export const activateDataDictionary = async (
  key: string,
  version: string,
): Promise<ApiResponse<string>> => {
  const response = await axiosProvider.apiClient.get<ApiResponse<string>>(
    `/program/${encodeURIComponent(
      getProductRouterPath(),
    )}/aws/activate-data-dictionary?key=${encodeURIComponent(
      key,
    )}&version=${encodeURIComponent(version)}`,
  );
  return response.data;
};

export const getLatestS3Version = async (): Promise<ApiResponse<AwsS3Like>> => {
  const response = await axiosProvider.apiClient.get<ApiResponse<AwsS3Like>>(
    `/program/${encodeURIComponent(
      getProductRouterPath(),
    )}/aws/latest-s3-version`,
  );
  return response.data;
};

export const getDiffsFromCurrentDataDictionary = async (
  version: string,
): Promise<ApiResponse<DataDictionaryDiff[]>> => {
  const response = await axiosProvider.apiClient.get<
    ApiResponse<DataDictionaryDiff[]>
  >(
    `/program/${encodeURIComponent(
      getProductRouterPath(),
    )}/aws/data-dictionary-diffs?version=${encodeURIComponent(version || '')}`,
  );
  return response.data;
};
